export interface IProps {
  type: ModalTypes;
  isVisible: boolean;
  onClose?: () => void;
  item?: any;
}

export enum ModalTypes {
  NONE = "none",
  PARTNERS = "partners",
  TEAM = "team"
}
